import React, { useMemo } from 'react'
import { Translate, withLocalize } from 'react-localize-redux';
import { EnhancedTable } from './EnhancedTable';
import PropTypes from 'prop-types';
import { FUNCTIONALITY } from '../../constants/types';
import { formatPatients } from '../../utils/index.jsx';
import { PERMISSION } from '../investigation/share/user_roles';

function PatientsTable(props) {
    
    const rows = useMemo(
        () => formatPatients(props.patients, props.personalFields, props.activeLanguage.code, props.insurances, props.coverages),
        [props.patients, props.personalFields, props.activeLanguage.code, props.insurances, props.coverages]
    );
    const headCells = props.personalFields.map(pField => {
        return { id: pField.name, alignment: "left", label: !props.translate(`investigation.create.personal_data.short-fields.${pField.name}`).includes("Missing") ? props.translate(`investigation.create.personal_data.short-fields.${pField.name}`) : pField.label }
    }) 
    let actions = [];
    if(props.permissions.includes(PERMISSION.MEDICAL_WRITE) && props.functionalities.includes(FUNCTIONALITY.HOSPITALIZATION)){
        actions.push({"type" : "hospital", "func" : (index) => props.hospitalizePatientCallBack(index)})
    }
    if(props.permissions.includes(PERMISSION.VIEW_BILLING) && props.functionalities.includes(FUNCTIONALITY.BILLING)){
        actions.push({"type" : "billing", "func" : (index) => props.billingPatientCallBack(index)})
    }
    if(props.permissions.includes(PERMISSION.CREATE_APPOINTMENTS) && props.functionalities.includes(FUNCTIONALITY.OUTPATIENTS)){
        actions.push({"type" : "appointment", "func" : (index) => props.selectAppointmentPatientCallBack(index)})
    }
    if(props.permissions.includes(PERMISSION.CREATE_SURGERY_APPOINTMENTS) && props.functionalities.includes(FUNCTIONALITY.SURGERY)){
        actions.push({"type" : "surgery", "func" : (index) => props.surgeryPatientCallBack(index)})
    }
    return (
        <EnhancedTable noHeader noSelectable  titleTable={<Translate id="investigation.create.summary.patients" />}
            rows={rows} headCells={headCells}
            selectRow={uuid => props.showPatientCallBack(uuid)}
            actions={actions}
            currentPage={props.currentPage}
            changePageCallback={props.changePageCallback}
            />
    )
}

PatientsTable.propTypes = {
    patients:PropTypes.array,
    mobile:PropTypes.bool,
    personalFields:PropTypes.array,
    showPatientCallBack:PropTypes.func,
    addInfoPatientCallBack:PropTypes.func,
    hospitalizePatientCallBack:PropTypes.func,
    billingPatientCallBack:PropTypes.func,
    selectAppointmentPatientCallBack:PropTypes.func,
    surgeryPatientCallBack:PropTypes.func,
    currentPage:PropTypes.number,
    changePageCallback:PropTypes.func
}

export default withLocalize(PatientsTable)